import CityServices from './CityServices';

export const CityServicesWrapper = ({ queryConfig }) => {
    return <CityServices queryConfig={queryConfig} />;
};
